export default __webpack_public_path__ + "static/media/Ballroll_00366.fab4356b.png";